export const MINIMUM_SEARCH_TERM_LENGTH = 2;

export const MAXIMUM_SEARCH_TERM_LENGTH = 60;
